<div id="insInformationWrapper">
  <div class="row d-flex justify-content-between">
    <div class="col-xs-10 col-md-10 col-lg-10">
      <h6 mat-dialog-title [id]="identifierService.titleId('ins-information', 'title')">
        {{'label.gb.pat_INS_info.text' | translate}}
      </h6>
    </div>
  </div>
  <mat-dialog-content>
    <div class="row">
      @if (isInsNumber) {
        <div class="valid-ins">
          <div class="col-xs-12 col-md-12 col-lg-12">
            <span [id]="identifierService.labelId('ins-information-dialog', 'pulledInsInfo')" class="labelText" [innerHTML]="translate('label.gb.pulled_INS_info.text') | safe: 'html'">
            </span>
          </div>
          <div  class="col-xs-12 col-md-12 col-lg-12">
            <div class="row p-40">
              <div class="col-xs-6 col-md-6 col-lg-6">
                <div [id]="identifierService.labelId('insInfoDialog', 'insNumber')" class="labelText" data-tx-key="label.gb.INSnumber_long">
                  {{ 'label.gb.INSnumber_long' | translate }}
                </div>
                <div [id]="identifierService.labelId('insInfoDialog', 'firstname')" class="labelText" data-tx-key="label.gb.firstname_long">
                  {{ 'label.gb.firstname_long' | translate }}
                </div>
                <div [id]="identifierService.labelId('insInfoDialog', 'givenNames')" class="labelText" data-tx-key="label.gb.givennames_long">
                  {{ 'label.gb.givennames_long' | translate }}
                </div>
                <div [id]="identifierService.labelId('insInfoDialog', 'firstnameUsed')" class="labelText" data-tx-key="label.gb.firstname_used_long">
                  {{ 'label.gb.firstname_used_long' | translate }}
                </div>
                <div [id]="identifierService.labelId('insInfoDialog', 'lastname')" class="labelText" data-tx-key="label.gb.lastname_long">
                  {{ 'label.gb.lastname_long' | translate }}
                </div>
                <div [id]="identifierService.labelId('insInfoDialog', 'lastnameUsed')" class="labelText" data-tx-key="label.gb.lastname_used_long">
                  {{ 'label.gb.lastname_used_long' | translate }}
                </div>
                <div [id]="identifierService.labelId('insInfoDialog', 'birthDate')" class="labelText" data-tx-key="label.gb.birth_date">
                  {{ 'label.gb.birth_date' | translate }}
                </div>
                <div [id]="identifierService.labelId('insInfoDialog', 'oid')" class="labelText" data-tx-key="label.gb.OID">
                  {{ 'label.gb.OID' | translate }}
                </div>
                <div [id]="identifierService.labelId('insInfoDialog', 'birthCode')" class="labelText" data-tx-key="label.gb.birth_code_long">
                  {{ 'label.gb.birth_code_long' | translate }}
                </div>
                <div [id]="identifierService.labelId('insInfoDialog', 'gender')" class="labelText" data-tx-key="label.gb.gender_long">
                  {{ 'label.gb.gender_long' | translate }}
                </div>
              </div>
              <div class="col-xs-6 col-md-6 col-lg-6">
                            <div class="labelText" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'insNumber'
                            )
                        ">
                  {{ patRes?.patient?.insNumber }}
                </div>
                            <div class="labelText" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'FirstName'
                            )
                        ">
                  {{ patRes?.patient?.firstName }}
                </div>
                            <div class="labelText" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'GivenName'
                            )
                        " [maxLength]="100">
                  {{ patRes?.patient?.givenNames }}
                </div>
                            <div class="labelText" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'usedGivenName'
                            )
                        ">
                  {{ patRes?.patient?.usedGivenName }}
                </div>
                            <div class="labelText" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'LastName'
                            )
                        ">
                  {{ patRes?.patient?.lastName }}
                </div>
                            <div class="labelText" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'UsedLastName'
                            )
                        ">
                  {{ patRes?.patient?.usedLastName }}
                </div>
                            <div class="labelText" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'DateOfBirthStr'
                            )
                        ">
                  {{ patRes?.patient?.dateOfBirthStr }}
                </div>
                            <div class="labelText" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'OidNumber'
                            )
                        ">
                  {{ patRes?.patient?.oidNumber }}
                </div>
                            <div class="labelText" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'PlaceOfBirth'
                            )
                        ">
                  {{ patRes?.patient?.placeOfBirth }}
                </div>
                            <div class="labelText" [id]="
                                identifierService.dropdownId(
                                    'ins-information',
                                    'Gender'
                                )
                            ">
                  {{ getGender() }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-12 col-lg-12 buttonClass">
            <button mat-raised-button class="btn-styl" color="accent"
                        matTooltip="{{'label.gb.button_cancel' | translate}}" (click)="cancel()" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'cancel'
                            )
                        ">
            {{ 'label.gb.button_cancel' | translate }}</button>&nbsp;&nbsp;
            <button mat-raised-button class="btn-styl" color="primary"
                        matTooltip="{{ 'label.gb.ok' | translate }}" (click)="confirm()" [id]="
                            identifierService.dropdownId(
                                'ins-information',
                                'confirm'
                            )
                        " data-tx-key="label.gb.ok">
            {{ 'label.gb.confirm' | translate }}</button>&nbsp;&nbsp;
          </div>
        </div>
      }
      <!-- <div class="invalid-ins" *ngIf="!isInsNumber">
      <div class="col-xs-12 col-md-12 col-lg-12">
        <span class="labelText">
          {{ 'msg.pat_cannot_enroll.text' | translate }}
        </span>
      </div>
    </div> -->
  </div>
</mat-dialog-content>

</div>